import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

import { SurveyType } from "../types";

const INITIAL_STATE: { surveyType: SurveyType } = { surveyType: "chat" };

const { useStore: useChatCsatStore, Provider: ChatCsatProvider } =
  createContextStore(INITIAL_STATE);

export { useChatCsatStore, ChatCsatProvider };
